import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLastTopics } from "@store/action/smartend/FilterAction";

const GalleryLast = ({ t }) => {
  const store = useSelector((state) => state.FilterReducer);
  const dispatch = useDispatch();
  const path = "Photos";
  const params2 = { number: 3 };
  const LastTopics = store.LastTopics;
  useEffect(() => {
    dispatch(getLastTopics(path, params2));
  }, [path]);

  return (
    <div className="treanding_songs_wrapper release_wrapper ms_cover">
      <div className="container" style={{ maxWidth: "80%" }}>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="ms_heading_wrapper">
              <h1>{t("Gallery")}</h1>
            </div>
            <div className="relaese_viewall_wrapper">
              <Link to={`/Gallery/Photos/topics`}>
                {t("view all")} <i className="flaticon-right-arrow" />
              </Link>
            </div>
          </div>
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="tab-content">
              <div className="row">
                {LastTopics.length
                  ? LastTopics.map((item, i) => {
                      return (
                        <div
                          className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 pd1"
                          key={i}
                        >
                          <div className="treanding_slider_main_box release_box_main_content ms_cover">
                            <img
                              height="350px"
                              src={item.photo_file && item.photo_file}
                              alt="suggest-1"
                            />
                            <div className="release_content_artist">
                              <p>
                                <Link to={`/Gallery/Photos/topics/${item.id}`}>
                                {item.title}
                                </Link>
                              </p>
                              {/* <p className="various_artist_text">
                                <Link to={`/Gallery/Photos/topics/${item.id}`}>
                                  {item.seo_description_en}
                                </Link>
                              </p> */}
                            </div>
                            <div className="ms_treanding_box_overlay release_box_overlay">
                              <div className="ms_tranding_box_overlay" />
                              <div className="tranding_play_icon">
                                <Link to={`/Gallery/Photos/topics/${item.id}`}>
                                  <i className="flaticon-right-arrow" />
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : ""}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryLast;
